export default "__VITE_ASSET__DXtkAoz$__"